import {
    infobarMessageSMIMESignatureValid,
    infobarMessageSMIMESignatureInvalid,
} from '../../strings.locstring.json';
import { SecurityDetailsText } from './SecurityDetails.locstring.json';
import loc from 'owa-localize';
import Section from './Section';
import { observer } from 'mobx-react';

import * as React from 'react';

interface SecurityDetailsProps {
    isSenderVerified: boolean;
}

const SecurityDetails = (props: SecurityDetailsProps) => {
    return (
        <Section title={loc(SecurityDetailsText)}>
            {props.isSenderVerified
                ? loc(infobarMessageSMIMESignatureValid)
                : loc(infobarMessageSMIMESignatureInvalid)}
        </Section>
    );
};

export default observer(SecurityDetails);
